import { createSagaActionTypes } from '../../../utils/actionFactory';

export const GET_PHOTO = 'GET_PHOTO';

export const actions = createSagaActionTypes('USER_AVATAR', [
  GET_PHOTO
]);
